import { useEffect, useState } from "react";
import Modal from "react-modal";
import { useNavigate, useParams } from "react-router-dom";
import Switch from "react-switch";
import { useOrder } from "../../hooks/useOrder";
import { MainButton } from "../MainButton";
import InputMask from "react-input-mask";
import { Store } from "./Store";
import Swal from "sweetalert2";

import "./index.css";
import { cnpj, cpf } from "cpf-cnpj-validator";
import api from "../../services/api";
import { usePluginspace } from "../../hooks/usePluginspace";
import { useSeller } from "../../hooks/useSeller";

type StoresType = {
	id: number;
	name: string;
	city: string;
	district: string;
	street: string;
	number: string;
	currentBalance: number;
	distance: string;
};

type ModalWithdrawalProps = {
	isOpen: boolean;
	setIsOpen: (value: boolean) => void;
	backgroundButton?: string;
	fontButton?: string;
	stores: Array<StoresType>;
};

type AddressLocationType = {
	cep: string;
	city: string;
	district: string;
	extra: string;
	number: string;
	state: string;
	street: string;
};

type LocationResponseType = {
	address: AddressLocationType;
	type: string;
	name: string;
	code: string;
};

export function ModalWithdrawal({
	isOpen,
	setIsOpen,
	backgroundButton,
	fontButton,
	stores,
}: ModalWithdrawalProps) {
	const navigate = useNavigate();
	const { pluginspace_id } = useParams();
	const { setType, setOrderAddress, setLocationId } = useOrder();
	const orderContext = useOrder();

	const [selectedStore, setSelectedStore] = useState<number>();

	const [otherPerson, setOtherPerson] = useState(false);
	const [nameOtherPerson, setNameOtherPerson] = useState("");
	const [alarmName, setAlarmName] = useState(false);
	const [cpfOtherPerson, setCpfOtherPerson] = useState("");
	const [alarmCpf, setAlarmCpf] = useState(false);

	const [maskCpfjCnpj, setMaskCpfjCnpj] = useState("999.999.999-99");

	const { getToken, getLocations } = usePluginspace();

	const { getTokenSeller } = useSeller();

	async function goToCustomer() {
		const store = stores.find((store) => store.id === selectedStore);
		if (
			store &&
			((otherPerson && cpfOtherPerson && cpfOtherPerson) || !otherPerson)
		) {
			if (
				cpfOtherPerson.length <= 14 &&
				otherPerson &&
				!cpf.isValid(cpf.strip(cpfOtherPerson))
			) {
				Swal.fire({
					icon: "error",
					title: "Erro",
					text: "CPF inválido",
				});
			} else if (
				cpfOtherPerson.length > 14 &&
				otherPerson &&
				!cnpj.isValid(cpfOtherPerson)
			) {
				Swal.fire({
					icon: "error",
					title: "Erro",
					text: "CNPJ inválido",
				});
			} else {
				setType("withdraw");

				const newLocation = await getLocations()
				const loc = newLocation.find(
					(location: LocationResponseType) =>
						location.type == "address"
				);
				const locationWithdraw = newLocation.find(
					(location: LocationResponseType) =>
						location.code == "withdraw"
				);
				setOrderAddress({
					address: loc.address.street,
					cep: loc.cep,
					state: loc.address.state,
					city: loc.address.city,
					complement: loc.address.extra,
					district: loc.address.district,
					name: store?.name,
					number: loc.address.number,
					reference: "",
					otherPersonToWithdrawal: otherPerson
						? { name: nameOtherPerson, cpf: cpfOtherPerson }
						: null,
				});
				setLocationId(locationWithdraw.id);

				const tk = getTokenSeller();



				if (tk?.profile === "seller") {
					navigate(`/${pluginspace_id}/sellerCustomer`)
				} else {

					navigate(`/${pluginspace_id}/customer`)
				}

				/*
					Validação das localizações da loja para que busque do localStorage.
					Caso exista não precisa buscar novamente, mais indicado para o FOOD

					Essa função vai ser replicada para o ModalWithDrawl e ModalDelivery,
					uma vez que fazem a pesquisa da location para recuperar alguns dados.

					

					07/12/2023 - Bernnardo Pestana


					A função abaixo foi replicada dentro da PluginSpaceContext
					Uma vez que é utilizada em 3 momentos.
				
				*/
				/*
				const locationsInLocalStore = localStorage.getItem('locations');
				if (locationsInLocalStore) {

					const newLocation = JSON.parse(locationsInLocalStore)

					const loc = newLocation.find(
						(location: LocationResponseType) =>
							location.type == "address"
					);
					const locationWithdraw = newLocation.find(
						(location: LocationResponseType) =>
							location.code == "withdraw"
					);
					setOrderAddress({
						address: loc.address.street,
						cep: loc.cep,
						state: loc.address.state,
						city: loc.address.city,
						complement: loc.address.extra,
						district: loc.address.district,
						name: store?.name,
						number: loc.address.number,
						reference: "",
						otherPersonToWithdrawal: otherPerson
							? { name: nameOtherPerson, cpf: cpfOtherPerson }
							: null,
					});
					setLocationId(locationWithdraw.id);

					const tk = getTokenSeller();



					if (tk?.profile === "seller") {
						navigate(`/${pluginspace_id}/sellerCustomer`)
					} else {

						navigate(`/${pluginspace_id}/customer`)
					}
				} else {
					await api
						.get(`/api/location`, {
							headers: {
								Authorization: `Bearer ${await getToken()}`,
							},
						})
						.then(async (response) => {
							const loc = response.data.data.find(
								(location: LocationResponseType) =>
									location.type == "address"
							);
							const locationWithdraw = response.data.data.find(
								(location: LocationResponseType) =>
									location.code == "withdraw"
							);
							setOrderAddress({
								address: loc.address.street,
								cep: loc.cep,
								state: loc.address.state,
								city: loc.address.city,
								complement: loc.address.extra,
								district: loc.address.district,
								name: store?.name,
								number: loc.address.number,
								reference: "",
								otherPersonToWithdrawal: otherPerson
									? { name: nameOtherPerson, cpf: cpfOtherPerson }
									: null,
							});
							setLocationId(locationWithdraw.id);

							const tk = getTokenSeller();



							if (tk?.profile === "seller") {
								navigate(`/${pluginspace_id}/sellerCustomer`)
							} else {

								navigate(`/${pluginspace_id}/customer`)
							}
						})
						.catch((err) => {
							console.log(err);
							Swal.fire({
								icon: "error",
								title: "Erro",
								text: "Erro ao encontrar loja",
							});
						});
				}
				*/
			}
		} else {
			Swal.fire({
				icon: "error",
				title: "Erro",
				text: "Verifique se preencheu todos os campos",
			});
		}
	}

	function setDefaultStore() {
		try {
			setSelectedStore(stores[0].id);
		} catch (error) {
			console.log(error);
		}
	}

	useEffect(() => {
		setDefaultStore();
	}, []);

	function changeMaskCpf(newDocument: string) {
		if (newDocument.length >= 14 && newDocument[13] !== "_") {
			setMaskCpfjCnpj("99.999.999/9999-99");
		} else {
			setMaskCpfjCnpj("999.999.999-99");
		}
	}

	return (
		<Modal
			isOpen={isOpen}
			onRequestClose={() => setIsOpen(false)}
			className="modal-withdrawal"
			contentLabel="Endereço para entrega"
			overlayClassName="overlay-modal"
			ariaHideApp={false}
		>
			<div className="modal-withdrawal-content">
				<div className="modal-withdrawal-body">
					<div className="title">
						<h2>Escolha o endereço para retirada</h2>
						<svg
							onClick={() => setIsOpen(false)}
							width="17"
							height="17"
							viewBox="0 0 17 17"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fillRule="evenodd"
								clipRule="evenodd"
								d="M0.978551 2.97126L6.957 8.94971L0.978551 14.9282L2.97137 16.921L8.94981 10.9425L14.9283 16.921L16.9211 14.9282L10.9426 8.94971L16.9211 2.97126L14.9283 0.978446L8.94981 6.95689L2.97137 0.978446L0.978551 2.97126Z"
								fill="#636363"
							/>
						</svg>
					</div>
					<div className="stores">
						{stores.map((store) => (
							<Store
								store={store}
								selectedStore={selectedStore}
								setSelectedStore={setSelectedStore}
							/>
						))}
					</div>
					<div className="other-person">
						<div className="choose">
							<p>
								Definir outra pessoa para retirar os produtos na
								loja
							</p>
							<Switch
								width={30}
								height={18}
								handleDiameter={10}
								checkedIcon={false}
								uncheckedIcon={false}
								onColor={"#636363"}
								offColor={"#C8C8C8"}
								onHandleColor={"#000"}
								onChange={() => setOtherPerson(!otherPerson)}
								checked={otherPerson}
							/>
						</div>
						{otherPerson && (
							<div className="other-person-data">
								<input
									type="text"
									placeholder="Nome:"
									value={nameOtherPerson}
									onChange={(event) =>
										setNameOtherPerson(event.target.value)
									}
									onBlur={() =>
										nameOtherPerson === ""
											? setAlarmName(true)
											: setAlarmName(false)
									}
								/>
								{alarmName && (
									<p className="alarm-text">
										Informe um nome
									</p>
								)}
								<InputMask
									mask={maskCpfjCnpj}
									type="text"
									value={cpfOtherPerson}
									onBeforeInputCapture={(event) =>
										changeMaskCpf(event.currentTarget.value)
									}
									onChange={(event) =>
										setCpfOtherPerson(event.target.value)
									}
									onBlur={() =>
										cpfOtherPerson === undefined ||
											cpfOtherPerson[0] === "_"
											? setAlarmCpf(true)
											: setAlarmCpf(false)
									}
									placeholder="CPF"
								/>
								{alarmCpf && (
									<p className="alarm-text">
										Informe um CPF/CNPJ
									</p>
								)}
							</div>
						)}
					</div>
					<div className="withdrawal-footer">
						<p>Para retirada, apresente documento com foto</p>
						<MainButton
							onClick={() => goToCustomer()}
							color={fontButton ? fontButton : "#636363"}
							backgroundColor={
								backgroundButton ? backgroundButton : "#EAEAEA"
							}
							text="RETIRAR NESTA LOJA"
						/>
					</div>
				</div>
			</div>
		</Modal>
	);
}
